import { render, staticRenderFns } from "./addressAction.vue?vue&type=template&id=c952a772&scoped=true&"
import script from "./addressAction.vue?vue&type=script&lang=js&"
export * from "./addressAction.vue?vue&type=script&lang=js&"
import style0 from "./addressAction.vue?vue&type=style&index=0&id=c952a772&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c952a772",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
